import HomePage from './components/Pages/HomePage/HomePage';

const routes = [
  {
    path: '/',
    exact: true,
    title: 'Homepage',
    component: HomePage
  }
];

export default routes;
